import { Component, OnInit } from '@angular/core';
import { MapService, StyleType } from '../map/map.service';

@Component({
  selector: 'app-map-select-style',
  templateUrl: './map-select-style.component.html',
  styleUrls: ['./map-select-style.component.scss']
})
export class MapSelectStyleComponent implements OnInit {

  style: StyleType = 'satellite';
  helpText = $localize`Satellite`;

  constructor(
    private mapService: MapService
  ) { }

  ngOnInit(): void {
  }

  toogle(): void {
    this.mapService.setStyle(this.style);

    if (this.style === 'satellite') {
      this.style = 'street';
      this.helpText = $localize`Street`;
    } else {
      this.style = 'satellite';
      this.helpText = $localize`Satellite`;
    }
  }


}
